import { createSlice } from "@reduxjs/toolkit";
import {
  fetchReportList,
  downLoadReportDatewise,
  downLoadCombineReportDatewise,
  downloadCsvDatewiseReport,
  downloadCsvCurrentReport
} from "../actions/reportsAction";

export const reports = createSlice({
  name: "reports",
  initialState: {
    reports: null,
    filePath: null,
    updatedAt: null,
    downloadFileOfCurrentDate: null,
    downloadFileOfCurrentDateCsv: null,
    downloadFileOfDate: null,
    downloadAllFilesOfDate: null,
        downloadFileOfDateCsv: null,
    downloadAllFilesOfDateCsv: null,
    emailReport: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isDownloadLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded: false,
    isManageWardPage: false,
  },
  reducers: {
    userReset: (state) => {
      // state.reports= null;
      state.error = null;
    },
    resetPopup: (state) => {
      state.isLoader = false;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.error = null;
    },
    setManageWardPage: (state) => {
      state.isManageWardPage = true;
    },
    resetManageWardPage: (state) => {
      state.isManageWardPage = false;
    },
  },
  extraReducers: {
    [fetchReportList.pending]: (state, payload) => {
      state.error = null;
      state.isDownloadLoader = true;
      state.isLoader = true;
    },
    [fetchReportList.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadFileOfCurrentDate = payload?.data?.filePath;
      console.log(
        "state.downloadFileOfCurrentDate",
        state.downloadFileOfCurrentDate
      );
      state.isDownloadLoader = false;
      state.isLoader = false;
    },
    [fetchReportList.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isDownloadLoader = false;
    },
 // current date csv download
    [downloadCsvCurrentReport.pending]: (state, payload) => {
      state.error = null;
      state.isDownloadLoader = true;
      state.isLoader = true;
    },
    [downloadCsvCurrentReport.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadFileOfCurrentDateCsv = payload?.data?.filePath;
      state.isDownloadLoader = false;
      state.isLoader = false;
    },
    [downloadCsvCurrentReport.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isDownloadLoader = false;
    },
    [downLoadReportDatewise.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
      state.isDownloadLoader = true;
    },
    [downLoadReportDatewise.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadFileOfDate = payload?.data?.filesByTimesArray;
      state.downloadAllFilesOfDate = payload?.data?.daySummaryFilePath;
      state.isDownloadLoader = false;
      state.isLoader = false;
    },
    [downLoadReportDatewise.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isDownloadLoader = false;
    },
    [downLoadCombineReportDatewise.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
      state.isDownloadLoader = true;
    },
      // date wise csv report download
    [downloadCsvDatewiseReport.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
      state.isDownloadLoader = true;
    },
    [downloadCsvDatewiseReport.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadFileOfDateCsv = payload?.data?.filesByTimesArray;
      state.downloadAllFilesOfDateCsv = payload?.data?.daySummaryFilePath;
      state.isDownloadLoader = false;
      state.isLoader = false;
    },
    [downloadCsvDatewiseReport.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isDownloadLoader = false;
    },

    [downLoadCombineReportDatewise.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadCombineFileOfDate = payload?.data?.filePath;
      console.log("state.downloadCombineFileOfDate", state.downloadCombineFileOfDate);
      state.isDownloadLoader = false;
    },
    [downLoadCombineReportDatewise.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    //
   
  },
});

// Action creators are generated for each case reducer function
export const {
  userReset,
  userSort,
  userSearch,
  resetPopup,
  setManageWardPage,
  resetManageWardPage,
} = reports.actions;

export default reports.reducer;
